import { ForwardedRef, forwardRef } from "react";
import RadioButtonOptionsSelect, {
  RadioButtonOptionsSelectProps,
} from "components/Shared/Forms/RadioButtonOptionsSelect";

const options = [true, false] as const;

type Option = typeof options[number];

function getLabel(option: Option) {
  if (option === true) return "Yes";
  if (option === false) return "No";
  return "Neither";
}

type Props = Omit<RadioButtonOptionsSelectProps<Option>, "options" | "labels">;

function BooleanRadioButtons(props: Props, ref: ForwardedRef<HTMLDivElement>) {
  return (
    <RadioButtonOptionsSelect {...{ ref, options, getLabel }} {...props} />
  );
}

export default forwardRef(BooleanRadioButtons);
